import React, { useEffect, useState } from 'react'
import { Box, Collapse, DialogTitle, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from '@mui/material'
import SummarizeIcon from '@mui/icons-material/Summarize';
//import PetsIcon from '@mui/icons-material/Pets';
import HomeIcon from '@mui/icons-material/Home'
import CancelIcon from '@mui/icons-material/Cancel';
import PeopleIcon from '@mui/icons-material/People';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CategoryIcon from '@mui/icons-material/Category';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import QrCodeIcon from '@mui/icons-material/QrCode';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import MailIcon from '@mui/icons-material/Mail';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import StorageIcon from '@mui/icons-material/Storage';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useValue } from '../context/ContextProvider';
import { Link, useNavigate } from 'react-router-dom';

const MenuDrawer = () => {

    const navigate = useNavigate();
    const { state: { drawerState, currentUser }, dispatch } = useValue();

    /*  Objeto con las rutas para las diferentes opciones del menu y Handler para 
        segun el menu elegido, redireccionar a la página correspondiente. */
    const routesObj = {
        travel: '/travel',
        marcas: '/marcas',
        productos: '/productos',
        marcas0: '/marcas0'
    };
    const handleMenu = (menuSeleccionado) => {
        //console.log(menuSeleccionado);
        dispatch({ type: 'CLOSE_DRAWER' });
        //navigate(routesObj[menuSeleccionado]);
        navigate(menuSeleccionado);
    };

    /* Array que maneja el renderizado del menu que se presenta en el drawer */
    let drawerOptions = [
        { "name": "home", "label": "Inicio", "route": "/", "icon": <HomeIcon />, "menuPadre": false, "permisos": ["superusuario", "administrador", "cajero"] },
        //{ "name": "travel", "label": "Travel", "route": "/travel", "icon": <SendIcon />, "menuPadre": false, "permisos": ["superusuario", "administrador", "cajero"] },
        { "name": "pos", "label": "Pos", "route": "/pos", "icon": <PointOfSaleIcon />, "menuPadre": false, "permisos": ["superusuario", "administrador", "cajero"] },
        { "name": "almacen", "label": "Almacen", "route": "/almacen", "icon": <WarehouseIcon />, "menuPadre": false, "permisos": ["superusuario", "administrador"]},
        { "name": "database", "label": "Gestión de Datos", "route": null, "icon": <StorageIcon />, "menuPadre": true, "index": 0, "permisos": ["superusuario", "administrador"], "submenus":
                [
                    { "name": "categorias", "label": "Categorias", "route": "/gestion/categorias", "icon": <CategoryIcon />, "permisos": ["superusuario", "administrador"] },
                    { "name": "marcas", "label": "Marcas", "route": "/gestion/marcas", "icon": <FactoryOutlinedIcon />, "permisos": ["superusuario", "administrador"] },
                    //{ "name": "preciospan", "label": "Precios Pan", "route": "/gestion/preciospan", "icon": <LocalOfferIcon />, "permisos": ["superusuario", "administrador"] },
                    { "name": "productos", "label": "Productos", "route": "/gestion/productos", "icon": <QrCodeIcon />, "permisos": ["superusuario", "administrador"] },
                    { "name": "proveedores", "label": "Proveedores", "route": "/gestion/proveedores", "icon": <LocalShippingIcon />, "permisos": ["superusuario", "administrador"] },
                    { "name": "usuarios", "label": "Usuarios", "route": "/gestion/usuarios", "icon": <PeopleIcon />, "permisos": ["superusuario"] },
                ],
        },
        //{ "name": "otromenu", "label": "Otro Menu", "route": "/otromenu", "icon": <WidgetsOutlinedIcon />, "menuPadre": false, "permisos": ["superusuario", "administrador"] },
        { "name": "reportes", "label": "Reportes", "route": null, "icon": <WidgetsOutlinedIcon />, "menuPadre": true, "index": 1, "permisos": ["superusuario", "administrador"], "submenus":
                [
                    { "name": "ventas", "label": "Ventas", "route": "/reportes/ventas", "icon": <FactoryOutlinedIcon />, "permisos": ["superusuario", "administrador", "cajero"] },
                    { "name": "almacen", "label": "Almacen", "route": "/reportes/almacen", "icon": <FactoryOutlinedIcon />, "permisos": ["superusuario", "administrador"] },
                ],
        },
    ];

    
    /* Genera el nuevo drawerOptions en función a los permisos del usuario */
    var newArray = [];
    drawerOptions.forEach((option) => {
        let visibilidad = false;
        visibilidad = option.permisos.includes(currentUser?.tipoUsuario);
        if(visibilidad && !option.menuPadre){
            newArray.push(option);
        }
        if(visibilidad && option.menuPadre){
            const submenusNew = option.submenus.filter((submenu) => {
                //console.log({submenu});
                return submenu.permisos.includes(currentUser?.tipoUsuario);
            })
            const optionNew = {...option, "submenus": submenusNew}
            //console.log({submenusNew, optionNew});
            newArray.push(optionNew);
        }
    })
    drawerOptions = newArray;
    

    /*  useState y Handler para gestionar los submenus, cuando se abren o cierran 
        Utiliza un objeto para mantener el estado de los diferentes submenus */
    const [submenusState, setSubmenusState] = useState([]);
    const handleClickSubmenus = (index) => {
        setSubmenusState({ ...submenusState, [index]: !submenusState[index] });
    };

    /*
    // Código que pretendía crear dinámicamente un array con los items suficienes para manejar los submenus 
    // según los permisos del usuario.  No se necesito porque React los crea autómaticamente cuando se usan por primera vez
    // En este código lo importante es el operador '=>' que en useState hace que una operación que altera el valor
    // de la variable se delegue a un queue, de modo que se actualiza correctamente luego.
    const [n, setN] = useState(0);
    //console.log({n})
    
    useEffect(() => {
        //Código que genera el array de estado de submenus, dinamicamente, poniendo todos en falso
        drawerOptions.forEach((option) => {
            if (option.menuPadre === true) {
                setSubmenusState2(submenusState2 => [...submenusState2, false]);    //En este caso el operador => es un operador que pone las operaciones en qeue
                setN( n => n + 1);
            }
        })
    },[])
    //console.log({submenusState2, n});
    */


    /*  Funcion que genera la lista de menus y submenus que se presentan en el drawer */
    const drawerList = () => (
        <Box
            sx={{ width: 250 }}
            role="presentation"
            onKeyDown={() => dispatch({ type: 'CLOSE_DRAWER' })}
        >
            <DialogTitle  style={{ display: 'flex', justifyContent: 'flex-end', padding: '0', backgroundColor: '#1976d2' }}>
                <IconButton sx={{ color: "#FFF" }} onClick={() => dispatch({ type: 'CLOSE_DRAWER' })}>
                    <CancelIcon />
                </IconButton>
            </DialogTitle>
            <Divider />

            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        Opciones de Gestión
                    </ListSubheader>
                }>

                {drawerOptions.map((option, index) => {
                    if (option.menuPadre === false) {
                        return (
                            <ListItemButton key={option.name} onClick={() => handleMenu(option.route)}>
                                <ListItemIcon key={option.name + 'Icon'}>
                                    {option.icon}
                                </ListItemIcon>
                                <ListItemText key={option.name + 'Text'} primary={option.label} />
                            </ListItemButton>
                        )
                    } else {
                        return (
                            <div key={option.name + 'Start'}>
                                <Divider key={option.name + 'Divider'}/>
                                <ListItemButton key={option.name + '2'} onClick={() => handleClickSubmenus(option.index)}>
                                    <ListItemIcon key={option.name + 'Icon2'}>
                                        {option.icon}
                                    </ListItemIcon>
                                    <ListItemText key={option.name + 'Text2'} primary={option.label} />
                                    {submenusState[option.index] ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                                <Collapse key={option.name + 'Collapse'} in={submenusState[option.index]} timeout="auto" unmountOnExit>
                                    <List key={option.name + 'List'} component="div" disablePadding>
                                        {option.submenus.map((submenu) => {
                                            return (
                                                <ListItemButton key={submenu.name + 'Button3'} sx={{ pl: 4 }} onClick={() => handleMenu(submenu.route)}>
                                                    <ListItemIcon key={option.name + 'Icon3'}>
                                                        {submenu.icon}
                                                    </ListItemIcon>
                                                    <ListItemText key={option.name + 'Text3'} primary={submenu.label} />
                                                </ListItemButton>

                                            )
                                        })}
                                    </List>
                                </Collapse>
                                <Divider key={option.name + 'Divider2'} />
                            </div>
                        )
                    }
                })}
           </List>
       </Box>
    )

    return (
        <>
            {/* Drawer es el menú principal, que sale del lado izquierdo de la pantalla.  Sólo se muestra cuando se hace
                click en el icono de menu.  NOTA. El elemento Drawer debe estar independiente para funcionar correctamente 
                (efectos de entrada y salida).  Independiente significa fuera del renderizado principal*/}
            <Drawer
                transitionDuration={{ appear: 300, enter: 300, exit: 200 }}
                open={drawerState}
                onClose={() => dispatch({ type: 'CLOSE_DRAWER' })}
            >
                {drawerList()}  {/* drawerList genera todo el menu que se muestra en el drawer */}
            </Drawer>
        </>
    )
}

export default MenuDrawer